import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { EnumIdsTcPais, Tc, TcPaisUsaCodigoPostal, WUnlocodeViewModel } from '../../../core/_infrastructure/types/common';
import { TSolicitanteAdministrativoViewModel } from '../../../_importacion/solicitudes/datosbasicos/datosbasicos.types';
import {
    EnumCodigosTwTcAcciones,
    EnumIdsTcFormatoSolicitud,
    EnumIdsTcTipoMedioTransporte,
    EnumIdsTcTipoPuntoInspeccion,
    EnumIdsTwTcTipoClonacion,
} from '../../../_importacion/solicitudes/types/enum';
import {
    EnumIdsTcEstadoSolicitudEx,
    EnumIdsTcEstadoCertificadoFitoEx,
    EnumIdsTcTipoSolicitudEx,
    EnumIdsTwTcSubTipoSolicitudEx,
    EnumIdsTwTcEstadoAvisoConfeccionEx,
    EnumLabelEstadoSolicitud,
    EnumLabelTipoSolicitudEx,
} from '../types/enum';
import { SolicitudExService } from './datosbasicosEx.service';
import {
    ParametrosNuevaSolicitudExViewModel,
    SolicitudExViewModel,
    TCampaniasDatosSolicExViewModel,
    TSolicitudAdministrativoExViewModel,
} from './datosbasicosEx.types';
import { UnlocodePopupComponent } from '../../../core/components/popup/unlocode/unlocodePopup.component';
import { PuntoInspeccionService } from '../../../_mantenimiento/general/puntosinspeccion/puntoinspeccion.service';

@Component({
    selector: 'app-solicitudex-edit',
    templateUrl: './solicitudEx-edit.component.html',
})
export class SolicitudExEditComponent extends ComponentBase implements OnInit {
    @ViewChild('unlocodePopup', { static: false }) private unlocodePopupComponent: UnlocodePopupComponent;

    private editMode = false;
    editTitle = 'Nueva';
    private paisRequiredMedioTransporte: boolean | null = false;
    esPrevia = false;
    campoObligatorio = true;
    tituloTipoSolicitudEx: string;
    tituloEstadoSolicitudEx: string;
    tituloEstadoCertificadoFitoEx: string;
    esClonada = false;
    private esAnulacionSustitucion = false;
    private IdPuntoInspeccion: number | null;
    IdPaisDestino: number | null;
    IdUbicacion: number | null;
    IdInstalacionAutorizada: number | null;
    esSolicitudGrabador = false;
    esGrabador = false;
    usaCodigoPostalPaisExportador = true;
    private codigoTipoSolicitud: string;
    hayNumeroCertificado = false;
    solicitudEnviada = false;
    private esCanarias = false;
    private esCampaniasEspec = false;
    private IdPeriodo: number | null;
    private AvisoConfeccion = false;
    private IdPaisPuntoEntradaUnlocode: number | null;
    private IdUnlocodeLocation: number | null;

    listPais: TcPaisUsaCodigoPostal[];
    listPuntoInspeccion: Tc[];
    listMedioTransporte: Tc[];
    listPaisesExpor: Tc[];
    listTipoEnvio: Tc[];
    listUbicacion: Tc[];
    listInstalacionAutorizada: Tc[];
    listIntervalo: Tc[];

    private IdSolicitanteEx: number | null = null;
    private IdSolicitanteAdministrativo: number | null = null;
    private IdGrabador: number | null = null;

    solicitudEx: SolicitudExViewModel;
    private solicitudPadreAnulSust: SolicitudExViewModel;
    mensajeSolicitudAnulSust = '';

    habilitarGuardar = true;
    private habilitarEdicion = true;
    habilitarSolicitanteAdministrativo = false;
    habilitarBotonCambiarPIF = false;

    visibilityDatosSolicitud = false;
    visibilityResultadoInspeccion = false;

    visibilitySpinnerGuardar = false;
    visibilitySpinnerInformeDatos = false;
    visibilitySpinnerInformeInspeccion = false;
    visibilitySpinnerCertificadofitosanitario = false;
    visibilitySpinnerEphyto = false;
    visibilitySpinnerDocumentoCertificadoPrevioExportacion = false;

    private paramsNuevaSolicitudEx: ParametrosNuevaSolicitudExViewModel | null;

    enviada = false;
    private laHeGrabadoYo = false;
    tieneAtestFito = false;
    tercerPaisConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_TERCER_PAIS_CON_ATEST_FITO;
    reExpConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_REEXPORTACION_CON_ATEST_FITO;
    canariasConAtestFito = EnumIdsTwTcSubTipoSolicitudEx.ID_CANARIAS_CON_ATEST_FITO;

    solicitanteCambiandoPIF = false;

    isCollapsedCabecera = false;
    isCollapsedExportador = false;
    isCollapsedDestinatario = false;
    isCollapsedSolicitante = false;
    isCollapsedSolicitanteAdministrativo = false;
    isCollapsedLugaresMercancia = false;
    isCollapsedMediosTransporte = false;
    isCollapsedDatosEnvio = false;
    isCollapsedDatosCF = false;
    isCollapsedDatosPapel = false;
    isCollapsedTerminosCondiciones = false;

    dialogUnlocodeVisible = false;

    idSolicitudEx: number;

    campoUbicacion = true;
    campoInstalacion = true;
    IdProvincia: number | null;
    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private navMenuService: NavMenuService,
        private solicitudExService: SolicitudExService,
        private changeDetector: ChangeDetectorRef,
        private puntoInspeccionService: PuntoInspeccionService,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.solicitudEx = new SolicitudExViewModel();
    }

    ngOnInit(): void {
        this.loadLists();

        this.paramsNuevaSolicitudEx = new ParametrosNuevaSolicitudExViewModel();
        this.paramsNuevaSolicitudEx = this.solicitudExService.getParamsSolicitudEx();

        this.createForm();

        this.idSolicitudEx = +this.activatedRoute.snapshot.params['id'];

        //EDIT de solicitudes
        if (this.idSolicitudEx) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.visibilityDatosSolicitud = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.IMPRIMIR_DATOS_SOLICITUD_EXPORTACION).Visible;

            //Para saber si se actúa como Inspector o Grabador
            let params = new HttpParams();
            params = params.append('idSolicitudEx', this.idSolicitudEx.toString());
            params = params.append('idUsuario', this.loggedInUser!.Id.toString());

            this.solicitudExService.isSolicitudUsuario(params).subscribe(resultIsGrabada => {
                this.laHeGrabadoYo = resultIsGrabada;

                this.solicitudExService.getSolicitudEx(this.idSolicitudEx).subscribe(result => {
                    this.navMenuService.currentSolicitudExportacion = result;

                    this.solicitudEx = result;

                    this.solicitudExService.currentIdSolicitudEx = this.solicitudEx.Id;

                    this.loadUbicacionesList(this.solicitudEx.IdPuntoInspeccion);
                    this.loadIntervaloList(this.solicitudEx.IdPuntoInspeccion);
                    this.loadInstalacionesList(this.solicitudEx.IdPuntoInspeccion);

                    this.esClonada =
                        this.solicitudEx.TwSolicitudJerarquiaEx != null &&
                        this.solicitudEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                            ? true
                            : false;

                    this.esAnulacionSustitucion =
                        this.solicitudEx.TwSolicitudJerarquiaEx != null &&
                        this.solicitudEx.TwSolicitudJerarquiaEx.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_ANULACION_SUSTITUCION
                            ? true
                            : false;

                    this.tituloTipoSolicitudEx = this.solicitudEx.TcTipoSolicitudEx.Descripcion;
                    this.codigoTipoSolicitud = this.solicitudEx.TcTipoSolicitudEx.Codigo;
                    this.tituloEstadoSolicitudEx = this.solicitudEx.TcEstadoSolicitudEx.Descripcion;
                    this.tituloEstadoCertificadoFitoEx = this.solicitudEx.TwTcEstadoCertificadoFitoEx.Descripcion;
                    this.IdSolicitanteEx = this.solicitudEx.IdUsuarioSolicitante;
                    this.IdSolicitanteAdministrativo = this.solicitudEx.IdUsuarioSolicitanteAdministrativo;
                    this.esPrevia = this.solicitudEx.EsPrevia;
                    this.IdPaisPuntoEntradaUnlocode = this.solicitudEx.TLugarMercanciaEx.IdPaisPuntoEntradaUnlocode;
                    this.IdUnlocodeLocation = this.solicitudEx.TLugarMercanciaEx.IdUnlocodeLocation;

                    this.IdPuntoInspeccion = this.solicitudEx.IdPuntoInspeccion;
                    this.IdUbicacion = this.solicitudEx.TLugarMercanciaEx.IdUbicacion;

                    this.enviada = this.solicitudEx.Codigo != null && this.solicitudEx.Codigo.length > 0;
                    this.esCampaniasEspec = this.solicitudEx.IdTipoSolicitudEx == EnumIdsTcTipoSolicitudEx.ID_CAMPANIAS_ESPECIFICAS;
                    this.AvisoConfeccion = this.solicitudEx.IdSubTipoSolicitudEx == EnumIdsTwTcSubTipoSolicitudEx.ID_CAMPANIAS_CON_AVISO_CONF ? true : false;
                    this.esSolicitudGrabador = this.solicitudEx.IdUsuarioSolicitanteAdministrativo != null;

                    if (this.solicitudEx.IdSubTipoSolicitudEx == this.reExpConAtestFito || this.tercerPaisConAtestFito || this.canariasConAtestFito) {
                        this.tieneAtestFito = true;
                    }

                    if (this.esSolicitudGrabador) {
                        this.IdGrabador = this.solicitudEx.TSolicitudAdministrativoEx.IdUsuarioGrabador;

                        this.addValidator('NifSolicitanteAdministrativo', Validators.required);
                        this.addValidator('NifSolicitanteAdministrativo', CustomValidator.NIFValidator);
                        this.addValidator('RazonSocialSolicitanteAdministrativo', Validators.required);
                        this.addValidator('NumeroTelefonoSolicitanteAdministrativo', Validators.required);
                        this.addValidator('FechaRegistro', Validators.required);

                        this.removeValidators('NifSolicitante');
                    }

                    this.addValidator('NIF', CustomValidator.NIFValidator);

                    this.form.controls['EsEphyto'].disable(); //Solo consulta siempre
                    this.form.controls['IdiomaDescripcion'].disable(); // Solo consulta siempre. #89173 - El inspector si lo podrá cambiar (en la pestaña de Envío) si el CF no está emitido.
                    this.updateForm();

                    // Si soy Inspector-Grabador
                    if (this.isGrabador && this.isInspector) {
                        this.habilitarGuardar =
                            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD_EXPORTACION, this.solicitudEx.IdEstadoSolicitudEx).Visible &&
                            this.laHeGrabadoYo;

                        this.habilitarEdicion =
                            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS_EXPORTACION, this.solicitudEx.IdEstadoSolicitudEx)
                                .Editable && this.laHeGrabadoYo;
                    } else {
                        this.habilitarGuardar = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD_EXPORTACION,
                            this.solicitudEx.IdEstadoSolicitudEx,
                        ).Visible;

                        this.habilitarEdicion = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS_EXPORTACION,
                            this.solicitudEx.IdEstadoSolicitudEx,
                        ).Editable;
                    }

                    this.solicitudEx.VieneDePreviaAceptada = this.solicitudEx.TPreviaInspectorEx?.Aceptada;

                    //Si soy Solicitante y la Solicitud está en estado de 'Borrador' y NO viene de una 'Previa Aceptada'
                    if (
                        this.isSolicitante &&
                        this.solicitudEx.IdEstadoSolicitudEx === EnumIdsTcEstadoSolicitudEx.ID_BORRADOR &&
                        !this.solicitudEx.VieneDePreviaAceptada
                    ) {
                        this.habilitarBotonCambiarPIF = true;
                    }

                    this.visibilityResultadoInspeccion = this.loggedInUser!.getAction(
                        EnumCodigosTwTcAcciones.IMPRIMIR_RESULTADO_INSPECCION_EXPORTACION,
                        this.solicitudEx.IdEstadoSolicitudEx,
                        this.solicitudEx.IdTipoSolicitudEx,
                    ).Visible;

                    //SI ES PREVIA
                    if (this.esPrevia) {
                        if (
                            this.solicitudEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA &&
                            this.solicitudEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE
                        ) {
                            this.tituloTipoSolicitudEx += EnumLabelTipoSolicitudEx.ID_PREVIA;
                        }

                        //Si ya la ha aceptado el inspector hay que validar como si ya no fuera PREVIA
                        if (this.solicitudEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA && !this.enviada) {
                            this.removeValidationsPrevia();
                            this.campoObligatorio = false;
                        }

                        if (this.solicitudEx.IdEstadoSolicitudEx == EnumIdsTcEstadoSolicitudEx.ID_PREVIA_PENDIENTE) {
                            this.campoObligatorio = false;
                        }
                    }

                    if (!this.habilitarEdicion) {
                        //metodo para deshabilitar los controles
                        this.disableControlsConsulta();

                        //Si soy Inspector y no tengo ya asignada la solicitud, preguntar si quiere asignarse la solicitud (para NUEVAS y EN TRAMITE)
                        if (
                            this.isInspector &&
                            this.loggedInUser!.Id != this.solicitudEx.IdInspector &&
                            (this.solicitudEx.IdEstadoSolicitudEx == EnumIdsTcEstadoSolicitudEx.ID_NUEVA ||
                                this.solicitudEx.IdEstadoSolicitudEx == EnumIdsTcEstadoSolicitudEx.ID_EN_TRAMITE)
                        ) {
                            this.confirmationService.confirm({
                                message: '¿Desea asignarse la solicitud?',
                                accept: () => {
                                    let params = new HttpParams();

                                    params = params.append('idSolicitud', this.solicitudEx.Id.toString());
                                    params = params.append('idUsuario', this.loggedInUser!.Id.toString());

                                    this.solicitudExService.asignarSolicitudEx(params).subscribe({
                                        next: () => {
                                            this.addSuccessMessage('Se ha asignado la solicitud correctamente');
                                            this.ngOnInit();
                                        },
                                        error: () => {
                                            this.addErrorMessage('Ha habido un error en la asignación');
                                        },
                                    });
                                },
                            });
                        }
                    } else {
                        this.disablePaisDestino();
                    }
                });
            });
        } //FIN EDIT
        else {
            //ALTA

            this.enviada = false;

            //hacemos el subscribe manual y no lo delegamos al async del HTML, volcamos a array de objetos para acceder al
            //valor de ciertas columnas al seleccionar un elemento
            this.globalService.getAllPaisesTcUsaCodigoPostalExpor().subscribe(res => {
                this.listPais = res;
            });

            this.esSolicitudGrabador = this.isGrabador;

            if (this.esSolicitudGrabador) {
                //Si es solicitud de grabador, actualizo validaciones
                this.addValidator('NifSolicitanteAdministrativo', Validators.required);
                this.addValidator('NifSolicitanteAdministrativo', CustomValidator.NIFValidator);
                this.addValidator('RazonSocialSolicitanteAdministrativo', Validators.required);
                this.addValidator('NumeroTelefonoSolicitanteAdministrativo', Validators.required);
                this.addValidator('FechaRegistro', Validators.required);
                this.removeValidators('NifSolicitante');

                this.IdGrabador = this.loggedInUser!.Id;
            } else {
                this.IdSolicitanteEx = this.loggedInUser!.Id;
                //Cargo los datos del Solicitante
                this.solicitudExService.getSolicitante(this.IdSolicitanteEx).subscribe(s =>
                    this.form.patchValue({
                        RazonSocial: s.RazonSocial,
                        NifSolicitante: s.NifCifRazonSocial,
                        NumeroTelefono: s.NumeroTelefono,
                    }),
                );
            }

            this.esPrevia = this.paramsNuevaSolicitudEx!.esPrevia;
            this.tituloEstadoSolicitudEx = EnumLabelEstadoSolicitud.ID_BORRADOR;
            this.tituloEstadoCertificadoFitoEx = EnumLabelEstadoSolicitud.ID_PENDIENTE;
            //Validacion sin rusia
            this.addValidator('PuntoEntrada', Validators.required);

            //Canarias. Se precarga el país del destinatario a España
            this.esCanarias = this.paramsNuevaSolicitudEx!.IdTipoSolicitudEx == EnumIdsTcTipoSolicitudEx.ID_CANARIAS;

            if (this.esCanarias) {
                this.form.patchValue({
                    IdPaisDestinatario: EnumIdsTcPais.ID_ESPANA,
                });
            }

            this.esCampaniasEspec = this.paramsNuevaSolicitudEx!.IdTipoSolicitudEx == EnumIdsTcTipoSolicitudEx.ID_CAMPANIAS_ESPECIFICAS;
            if (this.esCampaniasEspec) {
                this.IdPeriodo = this.paramsNuevaSolicitudEx!.IdPeriodo;
                this.AvisoConfeccion = this.paramsNuevaSolicitudEx!.AvisoConfeccion;
                //Si es solicitud de campañas sin Aviso de Confeccíon el estado es 'Aviso de Confección'
                if (this.AvisoConfeccion) {
                    this.form.patchValue({
                        IdEstadoSolicitudEx: EnumIdsTcEstadoSolicitudEx.ID_AVISO_CONFECCION,
                    });
                    this.tituloEstadoSolicitudEx = EnumLabelEstadoSolicitud.ID_AVISO_CONFECCION;
                }
            }

            this.codigoTipoSolicitud = this.paramsNuevaSolicitudEx!.tipoSolicitudEx;
            switch (this.codigoTipoSolicitud) {
                case 'T':
                    this.tituloTipoSolicitudEx = EnumLabelTipoSolicitudEx.ID_TERCER_PAIS;
                    if (this.esPrevia) {
                        this.tituloTipoSolicitudEx += EnumLabelTipoSolicitudEx.ID_PREVIA;
                        //elimino las validaciones normales
                        this.removeValidationsPrevia();
                        this.campoObligatorio = false;
                    }
                    break;
                case 'R':
                    this.tituloTipoSolicitudEx = EnumLabelTipoSolicitudEx.ID_RE_EXPORTACION;
                    break;
                case 'C':
                    this.tituloTipoSolicitudEx = EnumLabelTipoSolicitudEx.ID_CANARIAS;
                    break;
                case 'CE':
                    this.tituloTipoSolicitudEx = EnumLabelTipoSolicitudEx.ID_CAMPANIAS_ESPECIFICAS;
                    break;

                default:
            }

            this.habilitarGuardar = this.loggedInUser!.getAction(
                EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD_EXPORTACION,
                EnumIdsTcEstadoSolicitudEx.ID_BORRADOR,
            ).Visible;

            this.IdPuntoInspeccion = this.paramsNuevaSolicitudEx!.IdPuntoInspeccion;
            this.form.patchValue({
                IdPuntoInspeccion: this.paramsNuevaSolicitudEx!.IdPuntoInspeccion,
                IdPaisDestino: this.paramsNuevaSolicitudEx!.IdPaisDestino,
            });

            this.onSelectPuntoInspeccion();
            this.onSelectTipoMedioTransporte();

            this.IdUbicacion = this.paramsNuevaSolicitudEx!.IdUbicacion;
            this.IdInstalacionAutorizada = this.paramsNuevaSolicitudEx!.IdInstalacionAutorizada;
            this.IdPaisDestino = this.paramsNuevaSolicitudEx!.IdPaisDestino;
            this.tieneAtestFito = this.paramsNuevaSolicitudEx!.esAtestacionFitosanitaria;
            this.form.patchValue({
                IdUbicacion: this.paramsNuevaSolicitudEx!.IdUbicacion,
                IdInstalacionAutorizada: this.paramsNuevaSolicitudEx!.IdInstalacionAutorizada,
            });

            if (this.form.controls['IdUbicacion'].value != null) {
                this.campoUbicacion = true;
                this.campoInstalacion = false;
            } else {
                this.campoUbicacion = false;

                if (this.form.controls['IdInstalacionAutorizada'].value != null) {
                    this.campoInstalacion = true;
                }
            }
        } //FIN ALTA

        this.form.controls['IdPuntoInspeccion'].disable();
        this.disablePaisDestino();
        this.form.controls['IdUbicacion'].disable();
        this.form.controls['IdInstalacionAutorizada'].disable();
    }

    private getPuntosInspeccionSolicitudExport(): void {
        this.esGrabador = this.isGrabador;

        let params = new HttpParams();

        params = params.append('idpais', EnumIdsTcPais.ID_ESPANA.toString());
        params = params.append('esgrabador', this.esGrabador.toString());
        params = params.append('idusuario', this.loggedInUser!.Id.toString());

        this.globalService.getPuntoInspeccionNuevaSolicitudExportacion(params).subscribe(res => {
            this.listPuntoInspeccion = res;
        });
    }

    private loadLists(): void {
        if (!this.listPuntoInspeccion) {
            //this.globalService.getPuntoInspeccionByPais(EnumIdsTcPais.ID_ESPANA).subscribe(results => {
            //    this.listPuntoInspeccion = results;
            //}); //PROVISIONALMENTE
            this.getPuntosInspeccionSolicitudExport();
        }
        if (!this.listMedioTransporte) {
            this.globalService.getTipoMedioTransporteSinFerrocarril().subscribe(results => {
                this.listMedioTransporte = results;
            });
        }
        if (!this.listPaisesExpor) {
            this.globalService.getAllPaisesExpor().subscribe(results => {
                this.listPaisesExpor = results;
            });
        }
        if (!this.listTipoEnvio) {
            this.globalService.getTipoEnvio().subscribe(results => {
                this.listTipoEnvio = results;
            });
        }
        //if (!this.listInstalacionAutorizada) {
        //    this.globalService.getAllInstalacionesAutorizadas().subscribe(results => {
        //        this.listInstalacionAutorizada = results;
        //    });
        //}
    }

    private loadUbicacionesList(idPuntoInspeccion: number): void {
        this.globalService.getAllUbicacionByPuntoInspeccion(idPuntoInspeccion).subscribe(results => {
            this.listUbicacion = results;
        });
    }

    private loadIntervaloList(idPuntoInspeccion: number): void {
        this.globalService.getIntervaloHorasByPuntoInspeccion(idPuntoInspeccion).subscribe(results => {
            this.listIntervalo = results;
        });
    }

    private loadInstalacionesList(idPuntoInspeccion: number): void {
        this.puntoInspeccionService.getPuntoInspeccion(idPuntoInspeccion).subscribe(result => {
            this.IdProvincia = result.IdProvincia;
            this.globalService.getInstalacionesAutorizadasByProvincia(this.IdProvincia!).subscribe(res => {
                this.listInstalacionAutorizada = res;
            });
        });
    }

    private estableceMedioTransporte(idTipoPif: number | null): void {
        if (idTipoPif == EnumIdsTcTipoPuntoInspeccion.ID_AEROPUERTO) {
            this.form.patchValue({
                IdMedioTransporte: EnumIdsTcTipoMedioTransporte.ID_AVION,
            });
            //RDLF OJO!!: si deshabilito el campo no se envia en el submit, controlar esto
            //this.form.controls['IdMedioTransporte'].disable();
        } else if (idTipoPif == EnumIdsTcTipoPuntoInspeccion.ID_PUERTO) {
            this.form.patchValue({
                IdMedioTransporte: EnumIdsTcTipoMedioTransporte.ID_BARCO,
            });
        } else {
            this.form.patchValue({
                IdMedioTransporte: EnumIdsTcTipoMedioTransporte.ID_VEHICULO,
            });
        }
    }

    private disablePaisDestino(): void {
        if (this.esClonada && this.habilitarEdicion && !this.tieneAtestFito) {
            this.form.controls['IdPaisDestino'].enable();
        } else {
            this.form.controls['IdPaisDestino'].disable();
        }
    }

    private disableControlsConsulta(): void {
        this.form.controls['RefSolicitante'].disable();
        this.form.controls['NombreExportador'].disable();
        this.form.controls['IdPaisExportador'].disable();
        this.form.controls['LocalidadExportador'].disable();
        this.form.controls['DireccionExportador'].disable();
        this.form.controls['NifExportador'].disable();
        this.form.controls['CodigoPostalExportador'].disable();

        this.form.controls['NombreDestinatario'].disable();
        this.form.controls['CiudadDestinatario'].disable();
        this.form.controls['DireccionDestinatario'].disable();
        this.form.controls['IdPaisDestinatario'].disable();
        this.form.controls['NifDestinatario'].disable();
        this.form.controls['NumeroAfidi'].disable();
        this.form.controls['CodigoPostalDestinatario'].disable();

        if (this.esSolicitudGrabador) {
            this.form.controls['NifSolicitanteAdministrativo'].disable();
            this.form.controls['RazonSocialSolicitanteAdministrativo'].disable();
            this.form.controls['NumeroTelefonoSolicitanteAdministrativo'].disable();
            this.form.controls['FechaRegistro'].disable();
            this.form.controls['NRegistroPapel'].disable();
        }
        this.form.controls['IdPaisOrigen'].disable();
        this.disablePaisDestino();
        this.form.controls['IdUbicacion'].disable();
        this.form.controls['IdInstalacionAutorizada'].disable();
        this.form.controls['LugarOrigen'].disable();

        this.form.controls['FechaInspeccion'].disable();
        this.form.controls['IdIntervaloHoras'].disable();

        this.form.controls['IdMedioTransporte'].disable();
        this.form.controls['IdTipoEnvio'].disable();
        this.form.controls['NumeroOMI'].disable();

        this.form.controls['PermisoOLicenciaImp'].disable();
        this.form.controls['NormativaFito'].disable();
        this.form.controls['AceptarDeclaracion'].disable();
        this.form.controls['EsEphyto'].disable();
        this.form.controls['IdiomaDescripcion'].disable();
    }

    private removeValidationsPrevia(): void {
        this.removeValidators('IdPaisExportador');
        this.removeValidators('NombreExportador');
        this.removeValidators('LocalidadExportador');
        this.removeValidators('DireccionExportador');
        this.removeValidators('NifExportador');
        this.removeValidators('CodigoPostalExportador');

        this.removeValidators('NombreDestinatario');
        this.removeValidators('CiudadDestinatario');
        this.removeValidators('DireccionDestinatario');
        this.removeValidators('IdPaisDestinatario');
        this.removeValidators('CodigoPostalDestinatario');

        this.removeValidators('IdPaisOrigen');
        this.removeValidators('IdPaisDestino');
        this.removeValidators('PuntoEntrada');
        this.removeValidators('PaisPuntoEntradaUnlocode');

        this.removeValidators('IdUbicacion');
        this.removeValidators('IdInstalacionAutorizada');
        this.removeValidators('FechaInspeccion');

        this.removeValidators('IdMedioTransporte');
        this.removeValidators('IdTipoEnvio');
        this.removeValidators('NumeroOMI');
    }

    private createForm(): void {
        this.form = this.fb.group(
            {
                Codigo: null,
                FechaEnvio: null,
                HoraEnvio: null,
                FechaPresentacion: null,
                IdTipoSolicitudEx: this.paramsNuevaSolicitudEx != null ? this.paramsNuevaSolicitudEx!.IdTipoSolicitudEx : null,
                IdSubTipoSolicitudEx: this.paramsNuevaSolicitudEx != null ? this.paramsNuevaSolicitudEx!.IdSubTipoSolicitudEx : null,
                IdEstadoSolicitudEx: EnumIdsTcEstadoSolicitudEx.ID_BORRADOR, //ES EL ESTADO INICIAL POR DEFECTO
                IdEstadoCertificadoFitoEx: EnumIdsTcEstadoCertificadoFitoEx.ID_PENDIENTE,
                IdPuntoInspeccion: [null, Validators.required],
                RefSolicitante: '',

                NombreExportador: ['', Validators.required],
                LocalidadExportador: ['', Validators.required],
                DireccionExportador: ['', Validators.required],
                IdPaisExportador: [null, Validators.required],
                NifExportador: ['', Validators.compose([Validators.required, CustomValidator.NIFValidator])],
                CodigoPostalExportador: ['', Validators.required],

                NombreDestinatario: ['', Validators.required],
                CiudadDestinatario: ['', Validators.required],
                DireccionDestinatario: ['', Validators.required],
                IdPaisDestinatario: [null, Validators.required],
                NifDestinatario: '',
                CodigoPostalDestinatario: '',
                NumeroAfidi: '',

                RazonSocial: '',
                NumeroTelefono: '',
                NifSolicitante: '',
                RazonSocialSolicitanteAdministrativo: '',
                NifSolicitanteAdministrativo: '',
                NumeroTelefonoSolicitanteAdministrativo: '',
                FechaRegistro: '',
                NRegistroPapel: '',

                IdPaisOrigen: [null, Validators.required],
                IdPaisDestino: [null, Validators.required],
                PuntoEntrada: [null, Validators.required], // Contendrá el UnlocodeLocation
                PaisPuntoEntradaUnlocode: [null, Validators.required],

                LugarOrigen: '',
                IdUbicacion: [null, Validators.required],
                IdInstalacionAutorizada: [null, Validators.required],
                FechaInspeccion: '',
                IdIntervaloHoras: null,

                IdMedioTransporte: [null, Validators.required],
                NumeroOMI: '', //Todo:agaro. 03052022. Se quita de ser obligatorio el Buque/Awb [null, Validators.required],
                IdTipoEnvio: null,

                FechaCertificacion: '',
                NumeroCertificado: '',
                Pin: '',

                PermisoOLicenciaImp: false,
                NormativaFito: false,
                AceptarDeclaracion: false,

                EsEphyto: false,
                IdiomaDescripcion: '',
            },
            { validators: this.alMenosUnoValidator() },
        );
    }

    alMenosUnoValidator(): ValidatorFn {
        return (group: AbstractControl): ValidationErrors | null => {
            const ubicacion = group.get('IdUbicacion')?.value;
            const instalacion = group.get('IdInstalacionAutorizada')?.value;
            return !ubicacion && !instalacion ? { ubicacionOInstalacionRequerida: true } : null;
        };
    }

    onSelectInstalacionAutorizada() {
        //si instalacion es nulo
        if (this.form.controls['IdInstalacionAutorizada'].value === null) {
            this.form.controls['IdUbicacion'].enable();
            this.addValidator('IdUbicacion', Validators.required);
            this.campoUbicacion = true;
        }
        //si no deshabilito la Ubicacion
        else {
            this.form.controls['IdUbicacion'].disable();
            this.removeValidators('IdUbicacion');
            this.campoUbicacion = false;
        }
    }

    onSelectUbicacion() {
        //si ubicacion es nulo
        if (this.form.controls['IdUbicacion'].value === null) {
            this.form.controls['IdInstalacionAutorizada'].enable();
            this.addValidator('IdInstalacionAutorizada', Validators.required);
            this.campoInstalacion = true;
        }
        //si no deshabilito la Instalacion
        else {
            this.form.controls['IdInstalacionAutorizada'].disable();
            this.removeValidators('IdInstalacionAutorizada');
            this.campoInstalacion = false;
        }
    }

    private updateForm(): void {
        const puntoEntrada = this.getPuntoEntrada();

        this.form.setValue({
            Codigo: this.solicitudEx.Codigo,
            IdPuntoInspeccion: this.solicitudEx.IdPuntoInspeccion,
            FechaEnvio: this.datepipe.transform(this.solicitudEx.FechaEnvio, 'dd/MM/yyyy'),
            HoraEnvio: this.solicitudEx.HoraEnvio,
            FechaPresentacion: this.datepipe.transform(this.solicitudEx.FechaPresentacion, 'dd/MM/yyyy'),
            IdTipoSolicitudEx: this.solicitudEx.IdTipoSolicitudEx,
            IdSubTipoSolicitudEx: this.solicitudEx.IdSubTipoSolicitudEx,
            IdEstadoSolicitudEx: this.solicitudEx.IdEstadoSolicitudEx,
            IdEstadoCertificadoFitoEx: this.solicitudEx.IdEstadoCertificadoFitoEx,
            RefSolicitante: this.solicitudEx.RefSolicitante,

            IdPaisExportador: this.solicitudEx.TExportadorEx.IdPaisExportador,
            NombreExportador: this.solicitudEx.TExportadorEx.NombreExportador,
            LocalidadExportador: this.solicitudEx.TExportadorEx.LocalidadExportador,
            DireccionExportador: this.solicitudEx.TExportadorEx.DireccionExportador,
            NifExportador: this.solicitudEx.TExportadorEx.NifExportador,
            CodigoPostalExportador: this.solicitudEx.TExportadorEx.CodigoPostalExportador,

            NombreDestinatario: this.solicitudEx.TDestinatarioEx.NombreDestinatario,
            CiudadDestinatario: this.solicitudEx.TDestinatarioEx.CiudadDestinatario,
            DireccionDestinatario: this.solicitudEx.TDestinatarioEx.DireccionDestinatario,
            IdPaisDestinatario: this.solicitudEx.TDestinatarioEx.IdPaisDestinatario,
            NifDestinatario: this.solicitudEx.TDestinatarioEx.NifDestinatario,
            CodigoPostalDestinatario: this.solicitudEx.TDestinatarioEx.CodigoPostalDestinatario,
            NumeroAfidi: this.solicitudEx.TDestinatarioEx.NumeroAfidi,

            RazonSocial: this.solicitudEx.TwUsuarioExterno != null ? this.solicitudEx.TwUsuarioExterno.RazonSocial : null,
            NifSolicitante: this.solicitudEx.TwUsuarioExterno != null ? this.solicitudEx.TwUsuarioExterno.NifCifRazonSocial : null,
            NumeroTelefono: this.solicitudEx.TwUsuarioExterno != null ? this.solicitudEx.TwUsuarioExterno.NumeroTelefono : null,
            RazonSocialSolicitanteAdministrativo:
                this.solicitudEx.TSolicitanteAdministrativo != null ? this.solicitudEx.TSolicitanteAdministrativo.RazonSocialSolicitanteAdministrativo : null,
            NifSolicitanteAdministrativo:
                this.solicitudEx.TSolicitanteAdministrativo != null ? this.solicitudEx.TSolicitanteAdministrativo.NifSolicitanteAdministrativo : null,
            NumeroTelefonoSolicitanteAdministrativo:
                this.solicitudEx.TSolicitanteAdministrativo != null
                    ? this.solicitudEx.TSolicitanteAdministrativo.NumeroTelefonoSolicitanteAdministrativo
                    : null,

            IdPaisOrigen: this.solicitudEx.TLugarMercanciaEx.IdPaisOrigen,
            IdPaisDestino: this.solicitudEx.TLugarMercanciaEx.IdPaisDestino,
            PuntoEntrada: puntoEntrada.descripcion || null, // Contendrá la descripción del unlocode + descripción de subdivisión, desde la ventana de selección de Unlocode
            PaisPuntoEntradaUnlocode: this.solicitudEx.TLugarMercanciaEx.PaisPuntoEntradaUnlocode || null, // Contendrá la descripción del país, desde la ventana de selección de Unlocode

            LugarOrigen: this.solicitudEx.TLugarMercanciaEx.LugarOrigen,
            IdUbicacion: this.solicitudEx.TLugarMercanciaEx.IdUbicacion,
            IdInstalacionAutorizada: this.solicitudEx.TLugarMercanciaEx.IdInstalacionAutorizada,
            FechaInspeccion: this.solicitudEx.TLugarMercanciaEx.FechaInspeccion != null ? new Date(this.solicitudEx.TLugarMercanciaEx.FechaInspeccion) : null,
            IdIntervaloHoras: this.solicitudEx.TLugarMercanciaEx.IdIntervaloHoras,

            IdMedioTransporte: this.solicitudEx.TMedioTransporteEx.IdMedioTransporte,
            NumeroOMI: this.solicitudEx.TMedioTransporteEx.NumeroOMI,
            IdTipoEnvio: this.solicitudEx.TMedioTransporteEx.IdTipoEnvio,

            FechaCertificacion: this.datepipe.transform(this.solicitudEx.FechaCertificacion, 'dd/MM/yyyy'),
            NumeroCertificado: this.solicitudEx.NumeroCertificado,
            Pin: this.solicitudEx.TClaveCertCanarias != null ? this.solicitudEx.TClaveCertCanarias.Pin : '',
            FechaRegistro:
                this.solicitudEx.TSolicitudAdministrativoEx != null && this.solicitudEx.TSolicitudAdministrativoEx.FechaRegistro != null
                    ? new Date(this.solicitudEx.TSolicitudAdministrativoEx.FechaRegistro)
                    : '',
            NRegistroPapel: this.solicitudEx.TSolicitudAdministrativoEx != null ? this.solicitudEx.TSolicitudAdministrativoEx.NRegistroPapel : null,
            PermisoOLicenciaImp: this.solicitudEx.TwTerminosCondicionesEx.PermisoOLicenciaImp,
            NormativaFito: this.solicitudEx.TwTerminosCondicionesEx.NormativaFito,
            AceptarDeclaracion: this.solicitudEx.TwTerminosCondicionesEx.AceptarDeclaracion,
            EsEphyto: this.solicitudEx.EsEphyto,
            IdiomaDescripcion: this.solicitudEx.IdiomaDescripcion,
        });

        this.hayNumeroCertificado = this.solicitudEx.NumeroCertificado != null;
        this.solicitudEnviada = this.solicitudEx.Codigo != null;

        //Para controlar la visibilidad de los combos
        this.IdUbicacion = this.solicitudEx.TLugarMercanciaEx.IdUbicacion;
        this.IdInstalacionAutorizada = this.solicitudEx.TLugarMercanciaEx.IdInstalacionAutorizada;
        this.IdPaisDestino = this.solicitudEx.TLugarMercanciaEx.IdPaisDestino;

        //hacemos el subscribe manual y no lo delegamos al async del HTML, volcamos a array de objetos para acceder al
        //valor de ciertas columnas al seleccionar un elemento
        this.globalService.getAllPaisesTcUsaCodigoPostalExpor().subscribe(res => {
            this.listPais = res;

            if (!(this.esPrevia && this.solicitudEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA && !this.enviada)) {
                //PAIS EXPORTADOR
                const idPaisExportador = this.form.controls['IdPaisExportador'].value; //this.form.value.IdPaisExportador;
                let seleccionado = this.listPais.find(x => x.Id == idPaisExportador);
                if (seleccionado != null) {
                    this.usaCodigoPostalPaisExportador = (<TcPaisUsaCodigoPostal>seleccionado).UsaCodigoPostal;
                } else {
                    this.usaCodigoPostalPaisExportador = true; //RDLF: por defecto que sea obligatorio, por problemas con las de Canarias CF PREDUA
                }
                if (this.usaCodigoPostalPaisExportador!.valueOf() == true) {
                    this.addValidator('CodigoPostalExportador', Validators.required);
                } else {
                    this.removeValidators('CodigoPostalExportador');
                }
            }
        });

        if (this.form.controls['IdUbicacion'].value != null) {
            this.campoUbicacion = true;
            this.campoInstalacion = false;
        } else {
            this.campoUbicacion = false;

            if (this.form.controls['IdInstalacionAutorizada'].value != null) {
                this.campoInstalacion = true;
            }
        }
    }

    private getPuntoEntrada(): any {
        if (this.solicitudEx.TLugarMercanciaEx.PuntoEntradaDeclarado !== null) {
            return {
                id: null,
                descripcion: this.solicitudEx.TLugarMercanciaEx.PuntoEntradaDeclarado,
            };
        } else {
            return {
                id: this.solicitudEx.TLugarMercanciaEx.IdUnlocodeLocation,
                descripcion: this.solicitudEx.TLugarMercanciaEx.UnlocodeLocation, // Unlocode descripción + subdivisión descripción
            };
        }
    }

    saveSolicitud(): void {
        this.visibilitySpinnerGuardar = true;
        this.onSubmit();
    }

    private onSubmit(): void {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos de la solicitud');
            this.uncollapsePanels();
            this.visibilitySpinnerGuardar = false;
            return;
        }

        let solicitudEx = new SolicitudExViewModel();

        solicitudEx.IdTipoSolicitudEx = this.form.value.IdTipoSolicitudEx;
        solicitudEx.IdSubTipoSolicitudEx = this.form.value.IdSubTipoSolicitudEx;
        solicitudEx.AtestacionFito = this.tieneAtestFito;
        solicitudEx.Codigo = this.form.value.Codigo;
        solicitudEx.IdPuntoInspeccion = this.form.controls.IdPuntoInspeccion.value;
        solicitudEx.TLugarMercanciaEx.IdUbicacion = this.form.controls.IdUbicacion.value;
        solicitudEx.TLugarMercanciaEx.IdInstalacionAutorizada = this.form.controls.IdInstalacionAutorizada.value;
        solicitudEx.RefSolicitante = this.form.value.RefSolicitante;
        solicitudEx.IdUsuarioSolicitante = this.IdSolicitanteEx;

        if (this.solicitudEx.FechaCreacion != null) {
            solicitudEx.FechaCreacion = this.solicitudEx.FechaCreacion;
        }

        solicitudEx.TExportadorEx.NombreExportador = this.form.value.NombreExportador;
        solicitudEx.TExportadorEx.IdPaisExportador = this.form.value.IdPaisExportador;
        solicitudEx.TExportadorEx.LocalidadExportador = this.form.value.LocalidadExportador;
        solicitudEx.TExportadorEx.DireccionExportador = this.form.value.DireccionExportador;
        solicitudEx.TExportadorEx.NifExportador = this.form.value.NifExportador;
        solicitudEx.TExportadorEx.CodigoPostalExportador = this.form.value.CodigoPostalExportador;

        solicitudEx.TDestinatarioEx.NombreDestinatario = this.form.value.NombreDestinatario;
        solicitudEx.TDestinatarioEx.NifDestinatario = this.form.value.NifDestinatario;
        solicitudEx.TDestinatarioEx.IdPaisDestinatario = this.form.value.IdPaisDestinatario;
        solicitudEx.TDestinatarioEx.CiudadDestinatario = this.form.value.CiudadDestinatario;
        solicitudEx.TDestinatarioEx.DireccionDestinatario = this.form.value.DireccionDestinatario;
        solicitudEx.TDestinatarioEx.CodigoPostalDestinatario = this.form.value.CodigoPostalDestinatario;
        solicitudEx.TDestinatarioEx.NumeroAfidi = this.form.value.NumeroAfidi;

        //Si guardamos correctamente una Previa Aceptada pasa a ser 'Borrador'
        if (this.form.value.IdEstadoSolicitudEx == EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA) {
            solicitudEx.IdEstadoSolicitudEx = EnumIdsTcEstadoSolicitudEx.ID_BORRADOR;
        } else {
            solicitudEx.IdEstadoSolicitudEx = this.form.value.IdEstadoSolicitudEx;
        }

        solicitudEx.TLugarMercanciaEx.IdPaisOrigen = this.form.value.IdPaisOrigen;
        solicitudEx.TLugarMercanciaEx.IdPaisDestino = this.IdPaisDestino!;
        /*        solicitudEx.TLugarMercanciaEx.IdInstalacionAutorizada = this.IdInstalacionAutorizada!;*/
        solicitudEx.TLugarMercanciaEx.IdPaisPuntoEntradaUnlocode = this.IdPaisPuntoEntradaUnlocode!;
        solicitudEx.TLugarMercanciaEx.IdUnlocodeLocation = this.IdUnlocodeLocation!;

        // Ya no se guarda ésta información, que se actualizaba con el método anterior de selección del punto de entrada
        // solicitudEx.TLugarMercanciaEx.PuntoEntradaDeclarado = this.form.value.PuntoEntrada;
        // Ahora guardamos la información obtenida desde la ventana de diálogo de selección de Unlocode

        solicitudEx.TLugarMercanciaEx.LugarOrigen = this.form.value.LugarOrigen;
        solicitudEx.TLugarMercanciaEx.FechaInspeccion = this.form.value.FechaInspeccion;
        solicitudEx.TLugarMercanciaEx.IdIntervaloHoras = this.form.value.IdIntervaloHoras;

        solicitudEx.TMedioTransporteEx.IdMedioTransporte = this.form.value.IdMedioTransporte;
        solicitudEx.TMedioTransporteEx.NumeroOMI = this.form.value.NumeroOMI;
        solicitudEx.TMedioTransporteEx.IdTipoEnvio = this.form.value.IdTipoEnvio;

        solicitudEx.EsPrevia = this.esPrevia;

        //El Formato por defecto es 'Aplicacion'
        solicitudEx.IdFormatoSolicitudEx = EnumIdsTcFormatoSolicitud.ID_APLICACION;

        //SOLICITUD GRABADOR
        if (this.esSolicitudGrabador) {
            //Si es grabador es Formato 'Papel'
            solicitudEx.IdFormatoSolicitudEx = EnumIdsTcFormatoSolicitud.ID_PAPEL;

            solicitudEx.IdUsuarioSolicitanteAdministrativo = this.IdSolicitanteAdministrativo;

            solicitudEx.TSolicitudAdministrativoEx = new TSolicitudAdministrativoExViewModel();
            solicitudEx.TSolicitudAdministrativoEx.IdUsuarioGrabador = this.IdGrabador!;
            solicitudEx.TSolicitudAdministrativoEx.FechaRegistro = this.form.value.FechaRegistro;
            solicitudEx.TSolicitudAdministrativoEx.NRegistroPapel = this.form.value.NRegistroPapel;

            solicitudEx.TSolicitanteAdministrativo = new TSolicitanteAdministrativoViewModel();
            solicitudEx.TSolicitanteAdministrativo.Id = this.IdSolicitanteAdministrativo!;
            solicitudEx.TSolicitanteAdministrativo.NifSolicitanteAdministrativo = this.form.value.NifSolicitanteAdministrativo;
            solicitudEx.TSolicitanteAdministrativo.RazonSocialSolicitanteAdministrativo = this.form.value.RazonSocialSolicitanteAdministrativo;
            solicitudEx.TSolicitanteAdministrativo.NumeroTelefonoSolicitanteAdministrativo = this.form.value.NumeroTelefonoSolicitanteAdministrativo;
        }
        //SOLICITUD CAMPAÑAS
        if (this.esCampaniasEspec) {
            solicitudEx.TCampaniasDatosSolicEx = new TCampaniasDatosSolicExViewModel();
            solicitudEx.TCampaniasDatosSolicEx.IdPeriodo = this.IdPeriodo!;
            if (this.AvisoConfeccion) {
                solicitudEx.TCampaniasDatosSolicEx.IdEstadoAvisoConfeccion = EnumIdsTwTcEstadoAvisoConfeccionEx.ID_PENDIENTE;
            }
        }

        solicitudEx.TwTerminosCondicionesEx.PermisoOLicenciaImp = this.form.value.PermisoOLicenciaImp;
        solicitudEx.TwTerminosCondicionesEx.NormativaFito = this.form.value.NormativaFito;
        solicitudEx.TwTerminosCondicionesEx.AceptarDeclaracion = this.form.value.AceptarDeclaracion;

        solicitudEx.Id = this.solicitudEx.Id;

        if (this.editMode) {
            this.solicitudExService.editSolicitud(solicitudEx).subscribe({
                next: res => {
                    this.visibilitySpinnerGuardar = false;
                    this.addSuccessMessage('Solicitud modificada correctamente');

                    //Para forzar a refrescar el estado
                    if (
                        this.form.value.IdEstadoSolicitudEx === EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA ||
                        this.esClonada ||
                        this.esAnulacionSustitucion ||
                        this.solicitanteCambiandoPIF
                    ) {
                        this.form.controls['IdPuntoInspeccion'].disable();
                        this.form.controls['IdUbicacion'].disable();
                        this.form.controls['IdInstalacionAutorizada'].disable();
                        this.solicitanteCambiandoPIF = false;
                        this.ngOnInit();
                    }
                },
                error: error => {
                    this.visibilitySpinnerGuardar = false;
                    this.catchServerError(error);
                    this.uncollapsePanels();
                },
            });
        } else {
            //El idioma solo se guarda al crear, y no se modifica
            solicitudEx.IdIdioma = this.paramsNuevaSolicitudEx!.IdIdioma;

            this.solicitudExService.createSolicitud(solicitudEx).subscribe({
                next: res => {
                    this.visibilitySpinnerGuardar = false;
                    this.addSuccessMessage('Solicitud creada correctamente');
                    let idSolicitud = res;
                    this.router.navigate(['/exportacion/solicitud/datosbasicosEx/' + idSolicitud]);
                },
                error: error => {
                    this.visibilitySpinnerGuardar = false;
                    this.catchServerError(error);
                    this.uncollapsePanels();
                },
            });
        }
    }

    private uncollapsePanels(): void {
        this.isCollapsedCabecera = false;
        this.isCollapsedExportador = false;
        this.isCollapsedDestinatario = false;
        this.isCollapsedSolicitante = false;
        this.isCollapsedSolicitanteAdministrativo = false;
        this.isCollapsedLugaresMercancia = false;
        this.isCollapsedMediosTransporte = false;
        this.isCollapsedDatosEnvio = false;
        this.isCollapsedDatosCF = false;
        this.isCollapsedDatosPapel = false;
        this.isCollapsedTerminosCondiciones = false;
    }

    onChangePaisDestino(): void {
        const paisDestino = this.form.controls['IdPaisDestino'].value;
        if (paisDestino != this.IdPaisDestino) {
            this.clearPuntoEntradaFields(); // Forzamos al usuario a seleccionar de nuevo los países dependientes del País de Entrada
        }
        this.IdPaisDestino = paisDestino;
    }

    onSelectPuntoInspeccion(): void {
        //si el punto de inspección es nulo no hacemos nada
        if (this.IdPuntoInspeccion! == null && this.form.value.IdPuntoInspeccion == null) {
            this.form.patchValue({
                IdUbicacion: null,
                IdIntervaloHoras: null,
                NumeroDeclaracionSumaria: null,
                IdInstalacionAutorizada: null,
            });
            this.listUbicacion = [];
            this.listIntervalo = [];
            this.listInstalacionAutorizada = [];
            return;
        }

        let idPuntoInspeccion;

        if (this.editMode && !this.solicitanteCambiandoPIF) {
            idPuntoInspeccion = this.solicitudEx.IdPuntoInspeccion;
        } else if (this.solicitanteCambiandoPIF) {
            idPuntoInspeccion = this.form.value.IdPuntoInspeccion;

            this.loadUbicacionesList(idPuntoInspeccion);
            this.loadIntervaloList(idPuntoInspeccion);
            this.loadInstalacionesList(idPuntoInspeccion);

            this.form.patchValue({
                IdUbicacion: null,
                IdIntervaloHoras: null,
                NumeroDeclaracionSumaria: null,
                IdInstalacionAutorizada: null,
            });
        } else {
            idPuntoInspeccion = this.IdPuntoInspeccion! != null ? this.IdPuntoInspeccion! : this.form.value.IdPuntoInspeccion;

            this.loadUbicacionesList(idPuntoInspeccion);
            this.loadIntervaloList(idPuntoInspeccion);
            this.loadInstalacionesList(idPuntoInspeccion);

            this.form.patchValue({
                IdUbicacion: null,
                IdIntervaloHoras: null,
                NumeroDeclaracionSumaria: null,
                IdInstalacionAutorizada: null,
            });
        }
    }

    onChangePuntoInspeccion(): void {
        this.confirmationService.confirm({
            message: '¿Está seguro? Se borrarán todos los campos asociados al punto de inspección.',
            accept: () => {
                this.form.patchValue({
                    IdPuntoInspeccion: null,
                    IdUbicacion: null,
                    IdIntervaloHoras: null,
                    NumeroDeclaracionSumaria: null,
                    IdInstalacionAutorizada: null,
                });
                this.listUbicacion = [];
                this.listIntervalo = [];
                this.listInstalacionAutorizada = [];

                this.solicitanteCambiandoPIF = true;

                this.form.controls['IdPuntoInspeccion'].enable();
                this.form.controls['IdUbicacion'].enable();
                this.form.controls['IdInstalacionAutorizada'].enable();

                this.campoInstalacion = true;
                this.campoUbicacion = true;
            },
        });
    }

    onSelectTipoMedioTransporte(): void {
        //Si es previa no se valida nada
        if (!this.esPrevia && !(this.solicitudEx.IdEstadoSolicitudEx != EnumIdsTcEstadoSolicitudEx.ID_PREVIA_ACEPTADA && this.enviada)) {
            this.paisRequiredMedioTransporte = this.form.value.IdMedioTransporte == EnumIdsTcTipoMedioTransporte.ID_AVION ? false : true;

            if (this.paisRequiredMedioTransporte) {
                this.addValidator('IdPaisMedioTransporte', Validators.required);
            } else {
                this.removeValidators('IdPaisMedioTransporte');
            }
        }
    }

    onSelectPaisExportador(): void {
        const idPais = this.form.controls['IdPaisExportador'].value; //this.form.value.IdPaisExportador;

        let seleccionado = this.listPais.find(x => x.Id == idPais);

        if (seleccionado != null) {
            this.usaCodigoPostalPaisExportador = (<TcPaisUsaCodigoPostal>seleccionado).UsaCodigoPostal;
        }

        if (this.usaCodigoPostalPaisExportador!.valueOf() == true) {
            this.addValidator('CodigoPostalExportador', Validators.required);
        } else {
            this.removeValidators('CodigoPostalExportador');
        }
    }

    onSearchNifSolicitanteAdministrativo(): void {
        if (
            this.form.controls.NifSolicitanteAdministrativo.valid &&
            this.form.value.NifSolicitanteAdministrativo != null &&
            this.form.value.NifSolicitanteAdministrativo != ''
        ) {
            this.solicitudExService.getSolicitanteAdministrativo(this.form.value.NifSolicitanteAdministrativo).subscribe(s => {
                if (s != null) {
                    this.form.patchValue({
                        RazonSocialSolicitanteAdministrativo: s.RazonSocialSolicitanteAdministrativo,
                        NumeroTelefonoSolicitanteAdministrativo: s.NumeroTelefonoSolicitanteAdministrativo,
                    });
                    this.IdSolicitanteAdministrativo = s.Id;
                    this.habilitarSolicitanteAdministrativo = false;
                } else {
                    this.IdSolicitanteAdministrativo = 0;
                    this.addInfoMessage('No se encontró el NIF, introduzca los datos del solicitante.');
                    this.habilitarSolicitanteAdministrativo = true;
                }
            });
        } else {
            this.form.patchValue({
                RazonSocialSolicitanteAdministrativo: '',
                NumeroTelefonoSolicitanteAdministrativo: '',
            });
        }
    }

    onShowSolicitudPadreAnulSust(): void {
        this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => this.router.navigate(['/exportacion/solicitud/datosbasicosEx/' + this.solicitudPadreAnulSust.Id]));
    }

    onShowSolicitante(): void {
        this.router.navigate([this.router.url, 'solicitante', this.IdSolicitanteEx]);
    }

    onBack(): void {
        this.router.navigate(['/exportacion/solicitudes']);
    }

    /**
     * Se detecta el evento click para mostrar la ventana de diálogo de selección del Unlocode
     */
    onSearchUnlocode(): void {
        this.dialogUnlocodeVisible = true;
        this.changeDetector.detectChanges();
        setTimeout(() => {
            this.unlocodePopupComponent.showDialog();
        });
    }

    /**
     * La vuelta de la selección desde la ventana de diálogo que permite seleccionar el Unlocode (país y CodLocation, más descripciones)
     * @param seleccion WUnlocodeViewModel
     */
    onSelectUnlocode(seleccion: WUnlocodeViewModel): void {
        this.form.patchValue({
            PaisPuntoEntradaUnlocode: seleccion.Descripcion,
            PuntoEntrada: seleccion.DescripcionLocation, // + (seleccion.DescripcionSubDivision == null ? '' : ' ' + seleccion.DescripcionSubDivision),
        });
        this.IdPaisPuntoEntradaUnlocode = parseInt(seleccion.CodPais);
        this.IdUnlocodeLocation = seleccion.Id;
        this.form.markAsDirty();
        this.dialogUnlocodeVisible = false;
    }

    /**
     * Cuando cambia el país de destino, habrá que forzar al usuario a establecer de nuevo los campos relacionados con el País de Entrada
     */
    private clearPuntoEntradaFields(): void {
        this.form.patchValue({
            PaisPuntoEntradaUnlocode: '',
            PuntoEntrada: '',
        });
        this.IdPaisPuntoEntradaUnlocode = null;
        this.IdUnlocodeLocation = null;
        this.form.markAsDirty();
    }

    cargarDatosPrueba(): void {
        this.form.patchValue({
            Codigo: null,
            FechaEnvio: '',
            HoraEnvio: null,
            FechaPresentacion: '',
            IdPaisExportador: 149,
            IdTipoSolicitudEx: this.paramsNuevaSolicitudEx!.IdTipoSolicitudEx,
            NombreExportador: 'frutas y verduras s.l.',
            LocalidadExportador: 'cordoba',
            DireccionExportador: 'GREMI TEIXIDORS,4',
            NifExportador: '11111111H',
            CodigoPostalExportador: 28080,
            IdPaisDestinatario: 165,
            NombreDestinatario: 'verduras y hortalizas s.l.',
            CiudadDestinatario: 'valencia',
            DireccionDestinatario: 'Plaza Nueva,4',
            NifDestinatario: '00000000T',
            CodigoPostalDestinatario: 28080,

            RefSolicitante: 'prueba expor web',
            NIF: '11111111h',
            Nombre: '',
            Direccion: '',
            IdPaisOrigen: 12,
            IdPaisDestino: this.paramsNuevaSolicitudEx!.IdPaisDestino,
            PuntoEntrada: '',
            PaisPuntoEntradaUnlocode: '',
            LugarOrigen: 'Lugar de prueba',
            NumeroAfidi: '123456',
            IdUbicacion: this.paramsNuevaSolicitudEx!.IdUbicacion,
            IdInstalacionAutorizada: this.paramsNuevaSolicitudEx!.IdInstalacionAutorizada,
            FechaInspeccion: '',
            IdIntervaloHoras: null,
            NumeroOMI: 'uty57',
        });
    }

    printDocumentoDatosSolicitudEx(): void {
        this.visibilitySpinnerInformeDatos = true;
        this.solicitudExService.exportDocumentoDatosSolicitud(this.solicitudEx.Id).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinnerInformeDatos = false;
        });
    }

    printDocumentoResultadoInspeccionEx(): void {
        this.visibilitySpinnerInformeInspeccion = true;
        this.solicitudExService.exportDocumentoResultadoInspeccion(this.solicitudEx.Id).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinnerInformeInspeccion = false;
        });
    }

    // El usuario solicita que el botón esté habilitado a pesar de no estar todos los campos obligatorios rellenos
    // De ésta forma al hacer click en 'Guardar', la pantalla muestra los campos sin rellenar.

    get formInvalid(): boolean {
        return !this.form.valid || !this.form.dirty || this.form.pristine;
    }
}
